import React, { Component } from 'react';
import { AppTheme } from '../../styles/AppTheme';
import { CommonTheme } from '../../styles/Styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { emphasize, withStyles } from '@material-ui/core/styles';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

const StyledBreadcrumb = withStyles(theme => ({
  root: {
    backgroundColor: CommonTheme.textColor,
    height: theme.spacing(3),
    color: 'white',
    fontSize: '14px',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(CommonTheme.textColor),
      cursor: 'pointer'
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(CommonTheme.textColor),
    },
  },
}))(Chip);

export class BreadCrumbs extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(!this.props.breadCrumbs || this.props.breadCrumbs.length === 0) {
      return ''
    }

    return (
      <Route>
        <Breadcrumbs aria-label='Breadcrumb'>
          {this.props.breadCrumbs.map((item, index) => {
            const last = (index === this.props.breadCrumbs.length - 1);
            return last ? (
              <Typography
                style={{ color: 'black', fontSize: 15 }}
                key={index}>
                {item.title}
              </Typography>
            )
              :
              (
                <StyledBreadcrumb
                  component={RouterLink}
                  to={item.to}
                  key={index}
                  label={item.title}
                />
              );
          })}
        </Breadcrumbs>
      </Route>
    );
  }

}



// WEBPACK FOOTER //
// ./src/common/components/BreadCrumbs.js